import Button from "../../../../../Components/Common/Button/Button";
import ResidentialIcon from "Assets/Img/ResidentialIcon";
import CommercialIcon from "Assets/Img/CommercialIcon";
import { NewProjectFormValues } from "../types";
import { FormikErrors, FormikTouched } from "formik";

interface Step1ProjectTypeProps {
  values: NewProjectFormValues;
  errors: FormikErrors<NewProjectFormValues>;
  touched: FormikTouched<NewProjectFormValues>;
  setFieldValue: (name: string, value: string) => void;
  onNext: () => void;
}

export default function Step1ProjectType({
  values,
  errors,
  touched,
  setFieldValue,
  onNext,
}: Step1ProjectTypeProps) {
  const hasError = touched.projectType && errors.projectType;

  const selectType = (type: string) => setFieldValue("projectType", type);

  return (
    <div className="stepPanel active">
      <div className="card">
        <div className="cardTitle">What type of project is this?</div>
        <p className="projectTypeIntroText">
          The project type determines the pre-construction checklist
          requirements if a pre-construction review is needed.
        </p>
        <div className="typeGrid" id="projectType">
          <div
            className={`typeCard ${values.projectType === "residential" ? "selected" : ""}`}
            onClick={() => selectType("residential")}
          >
            <div className="tcIcon">
              <ResidentialIcon />
            </div>
            <div className="tcTitle">Residential</div>
            <div className="tcDesc">
              Single family homes, condos, apartments, townhouses, and other
              residential projects.
            </div>
          </div>
          <div
            className={`typeCard ${values.projectType === "commercial" ? "selected" : ""}`}
            onClick={() => selectType("commercial")}
          >
            <div className="tcIcon">
              <CommercialIcon />
            </div>
            <div className="tcTitle">Commercial</div>
            <div className="tcDesc">
              Mixed-use, retail, office, industrial, and other commercial
              projects.
            </div>
          </div>
        </div>
      </div>
      {hasError && <p className="field-error">{errors.projectType}</p>}
      <div className="btnRow">
        <div></div>
        <Button
          className="btn btnPrimary"
          disabled={!values.projectType}
          onClick={onNext}
        >
          Next: Project Info →
        </Button>
      </div>
    </div>
  );
}
